export default {
	symbolsKeyValue: 'Абв',
	layout: [
		['й', 'ц', 'у', 'к', 'е', 'н', 'г', 'ш', 'щ', 'з', 'х', 'ъ'],
		['ф', 'ы', 'в', 'а', 'п', 'р', 'о', 'л', 'д', 'ж', 'э'],
		['я', 'ч', 'с', 'м', 'и', 'т', 'ь', 'б', 'ю'],
	]
};
